import _ from 'lodash'

export default {
  computed: {
    modProps () {
      const result = {}
      _.each(this.$attrs, (value, key) => {
        if (key.startsWith('mod')) {
          result[key] = value
        }
      })
      return result
    }
  }
}
